"use strict";
var payment_iframe_component_1 = require("./payment-iframe.component");
exports.PaymentIFrameComponent = payment_iframe_component_1.PaymentIFrameComponent;
var card_iframe_service_1 = require("./card-iframe.service");
exports.CardIFrameService = card_iframe_service_1.CardIFrameService;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/payments/index.js